<!--'MEMBERS' for setting title is an exception and patientLabel is handled by breadcrumb -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'MEMBERS'" [breadcrumb]="breadcrumb"
  [isStringLiteral]="stringLiteralBreadcrumb" [count]="total" icon="fa-users">
</app-breadcrumb>
<div class="content-background">
  <div class="row">
    <div class="col-sm-12">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="memberGridAdvancedSwitch" [storageKey]="'members-list'"
          (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-PATIENT-OR-ID' | translate }}"
          title="{{ 'SEARCH-PATIENT-OR-ID' | translate }}" [formControl]="searchControl" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <kendo-grid #grid *ngIf="columnsConfig && columnsConfig.length > 0" [data]="gridView" [navigable]="true"
      [pageable]="isRestrictedPaging ? true : (total > state.take ? { buttonCount: 5, pageSizes: pageSizes } : false)"
      [pageSize]="state.take" [skip]="state.skip" [sort]="state.sort" [loading]="loading" [filter]="state.filter"
      [sortable]="true" [filterable]="enableAdvanced" [filter]="state.filter" [selectable]="{ mode: 'single' }"
      [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
      (dataStateChange)="dataStateChange($event)" (columnVisibilityChange)="onVisibilityChange($event)"
      (columnResize)="onResize($event)" (columnReorder)="onReorder($event)" (pageChange)="pageChange($event)">
      <kendo-grid-messages noRecords="{{ 'NO-MEMBERS' | translate:patientLabel }}">
      </kendo-grid-messages>
      <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
        <button kendoButton (click)="refresh()" class="float-right">{{'GRID-REFRESH' | translate }}<i
            class="far fa-sync-alt mt-1"></i>
        </button>
        <button kendoButton (click)="resetGridColumns()" class="float-right">{{'RESET-GRID-COLUMNS' | translate }}
        </button>
        <button kendoButton (click)="filterDialogOpened=true">{{ 'SAVE-FILTER' | translate }}</button>
      </ng-template>
      <kendo-grid-column *ngFor="let col of columnsConfig" [field]="col.field" [title]="col.title" [width]="col.width"
        [format]="col.format" [filterable]="col.filterable !== undefined ? col.filterable : true" [filter]="col.filter"
        [sortable]="col.sortable !== undefined ? col.sortable : true"
        [columnMenu]="col.columnMenu !== undefined ? col.columnMenu : true"
        [class]="col.class !== undefined ? (col.class + ' grid-column-'+col.field.replace('.','-')) : 'grid-column-'+col.field.replace('.','-')"
        [hidden]="col.hidden !== undefined ? col.hidden : false">
        <!--fullName-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'fullName'">
          <a *ngIf="dataItem.consentAllowed && !dataItem.patientRestricted && !dataItem.patientOptedOutAndRestricted"
            [routerLink]="['/patient', dataItem.id]" [queryParams]="{breadcrumb: breadcrumb}"
            class="pointer emphasizedLabel">
            {{ dataItem.fullName }}
          </a>
          <span
            *ngIf="!dataItem.consentAllowed || dataItem.patientRestricted || dataItem.patientOptedOutAndRestricted">{{
            dataItem.fullName }}</span>
        </ng-template>
        <!--preferredName-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'preferredName'">
          <a *ngIf="dataItem.consentAllowed && !dataItem.patientRestricted && !dataItem.patientOptedOutAndRestricted && dataItem.preferredName"
            [routerLink]="['/patient', dataItem.id]" [queryParams]="{breadcrumb: breadcrumb}"
            class="pointer emphasizedLabel">
            {{ dataItem.preferredName }}
          </a>
          <span
            *ngIf="!dataItem.consentAllowed || dataItem.patientRestricted || dataItem.patientOptedOutAndRestricted">{{
            dataItem.preferredName }}</span>
        </ng-template>
        <!--homePhoneNumber-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'homePhoneNumber'">
          {{dataItem.homePhoneNumber | phone}}
        </ng-template>
        <!--dateOfBirth-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'dateOfBirth'">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
        <!--compositeRiskScore-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column"
          *ngIf="col.field === 'compositeRiskScore'">
          <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte" [spinners]="false">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
            <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
            <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
          </kendo-grid-numeric-filter-cell>
        </ng-template>
        <!--gender-->
        <ng-template kendoGridFilterCellTemplate let-filter *ngIf="col.field === 'gender'">
          <app-dropdown-filter [filter]="filter" [data]="genders" filterField="gender" textField="displayName"
            valueField="displayName" ariaLabel="{{'GENDER' | translate}}">
          </app-dropdown-filter>
        </ng-template>
        <!--inviteStatus-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'inviteStatus'">
          <div *ngIf="!dataItem.patientRestricted && !dataItem.patientOptedOut">
            <a *ngIf="dataItem.inviteStatus === null" title="{{'COMMUNITY-INVITE-SEND' | translate}}"
              (click)="openMethodDialog(dataItem,'INVITE')" tabindex="0"
              (keydown.enter)="openMethodDialog(dataItem,'INVITE')"
              (keydown.space)="openMethodDialog(dataItem,'INVITE')">
              <i class="fas fa-envelope fa-send-document-action fa-lg"></i>
            </a>
            <a *ngIf="dataItem.inviteStatus === 'REGISTERED'"
              title="{{'COMMUNITY-INVITE-REGISTERED-ON' | translate}}{{dataItem.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(dataItem)}}">
              <i class="fas fa-user-check icon-success fa-lg pl-2"></i>
            </a>
            <a *ngIf="dataItem.inviteStatus === 'SENT'"
              title="{{'COMMUNITY-INVITE-SENT-ON' | translate}}{{dataItem.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(dataItem)}}">
              <i class="fas fa-paper-plane icon-warn fa-lg"></i>
            </a>
            <a *ngIf="dataItem.inviteStatus === 'EXPIRED'"
              title="{{'COMMUNITY-INVITE-EXPIRED' | translate}}{{dataItem.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(dataItem)}}">
              <i class="fas fa-ban icon-danger fa-lg"></i>
            </a>
            <a *ngIf="dataItem.inviteStatus === 'SENT' || dataItem.inviteStatus === 'EXPIRED'"
              title="{{'COMMUNITY-INVITE-RESEND' | translate}}" class="ml-2 pointer"
              (click)="openMethodDialog(dataItem,'INVITE')" tabindex="0"
              (keydown.enter)="openMethodDialog(dataItem,'INVITE')"
              (keydown.space)="openMethodDialog(dataItem,'INVITE')">
              <i class="fas fa-share icon-info fa-lg"></i>
            </a>
          </div>
        </ng-template>
        <!--consent-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'consent'">
          @if (dataItem.optOutDate) {
          <i class="fas fa-minus-hexagon fa-lg" [title]="getOptOutDateTitle(dataItem.optOutDate, dataItem.optOutReason)"
            style="color:#cf4526">
          </i>
          }
          @else {
          <a *ngIf="dataItem.consent === null && dataItem.consentRequired" class="pointer" tabindex="0"
            title="{{'REQUEST-CONSENT' | translate}}" (click)="openMethodDialog(dataItem,'CONSENT')"
            (keydown.enter)="openMethodDialog(dataItem,'CONSENT')"
            (keydown.space)="openMethodDialog(dataItem,'CONSENT')">
            <i class="far fa-user icon-info fa-lg" role="img" attr.aria-label="{{'REQUEST-CONSENT' | translate}}"></i>
          </a>
          <i *ngIf="!dataItem.consentRequired && dataItem.consent === null" class="far fa-unlock icon-success fa-lg"
            title="{{'NOT-CONSENTED' | translate}}"></i>
          <a *ngIf="dataItem.consent === 'REJECTED'"
            title="{{'CONSENT-REJECTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
            <i class="fas fa-user-lock icon-danger fa-lg" role="img"
              attr.aria-label="{{'CONSENT-REJECTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
          </a>
          <a *ngIf="dataItem.consent === 'REVOKED'"
            title="{{'CONSENT-REVOKED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
            <i class="fas fa-user-lock icon-danger fa-lg" role="img"
              attr.aria-label="{{'CONSENT-REVOKED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
          </a>
          <a *ngIf="dataItem.consent === 'REQUESTED'"
            title="{{'CONSENT-REQUESTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
            <i class="fas fa-user-cog icon-warn fa-lg" role="img"
              attr.aria-label="{{'CONSENT-REQUESTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
          </a>
          <a *ngIf="dataItem.consent === 'REQUESTED' || dataItem.consent === 'REJECTED' || dataItem.consent === 'REVOKED'"
            title="{{'RESEND-REQUEST' | translate}}" class="ml-2 pointer" tabindex="0"
            (click)="openMethodDialog(dataItem,'CONSENT')" (keydown.enter)="openMethodDialog(dataItem,'CONSENT')"
            (keydown.space)="openMethodDialog(dataItem,'CONSENT')">
            <i class="fas fa-share icon-info fa-lg" role="img" attr.aria-label="{{'RESEND-REQUEST' | translate}}"></i>
          </a>
          <a *ngIf="dataItem.consent === 'ACCEPTED'" tabindex="0"
            title="{{'CONSENT-ACCEPTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}">
            <i class="fas fa-user-unlock icon-success fa-lg" role="img"
              attr.aria-label="{{'CONSENT-ACCEPTED-ON' | translate}}{{dataItem.consentLastUpdate | date: 'MMM d, y, h:mm a'}}"></i>
          </a>
          }
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.filter === 'numeric'">
          <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
          </kendo-grid-numeric-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoPagerTemplate *ngIf="isRestrictedPaging">
        <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
    <button id="expandBtn" class="float-right mt-3 mb-3" kendoButton [primary]="true" type="button"
      (click)="memberDialogOpened = true">
      {{'ADD-MEMBER' | translate:patientLabel}}<i class="far fa-plus"></i>
    </button>
  </div>

  <!-- member form dialog -->
  <div class="k-overlay" *ngIf="memberDialogOpened"></div>
  <kendo-window [width]="1500" *ngIf="memberDialogOpened" (close)="memberDialogOpened = false" style="position:fixed"
    [top]="60" [state]="windowState">
    <kendo-window-titlebar>
      <div class="k-window-title">
        <h3>{{'ADD-MEMBER' | translate:patientLabel}}</h3>
      </div>
      <button kendoWindowMaximizeAction></button>
      <button kendoWindowRestoreAction></button>
      <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-patient-edit [isNew]="true" #memberEdit (saved)="onMemberAdded()" (applied)="onMemberApplied()">
    </app-patient-edit>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
      <button kendoButton type="button" (click)="memberDialogOpened = false">
        {{ 'CANCEL' | translate}}
      </button>
      <button appPreventClick preventTime="8000" kendoButton type="button"
        [disabled]="!memberEdit.formValid() || memberEdit.formSaving()" (click)="memberEdit.apply();">
        {{ 'APPLY' | translate}}
      </button>
      <button appPreventClick preventTime="8000" kendoButton type="button"
        [disabled]="!memberEdit.formValid() || memberEdit.formSaving()" (click)="memberEdit.save();">
        {{ 'SAVE' | translate}}
      </button>
    </kendo-dialog-actions>
  </kendo-window>

  <!-- save filter dialog -->
  <app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'Member'" [filterState]="state"
    [filterColumns]="columnsConfig" (cancelling)="filterDialogOpened=false;" [filter]="filterSelected">
  </app-save-filter>

  <app-member-send-selection [memberSelected]="memberSelected" [open]="openSendMethodDialog" [type]="sendMethodType"
    (closing)="closeSendMethod($event)">
  </app-member-send-selection>